import EmployeeLoanList from '../../../components/People/EmployeeLoan/EmployeeLoanList'
import EmployeeLoanModal from '../../../components/People/EmployeeLoan/EmployeeLoanModal'
import PageTitle from '../../../elements/PageTitle'
import {Breadcrumb, Card, Layout, Row} from 'antd'
import React, {Fragment} from 'react'

const {Content} = Layout

function EmployeeLoan(props) {
  return (
    <Fragment>
      <Content style={{margin: '0px 0px'}}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/people/dashboard/">HR</Breadcrumb.Item>
              <Breadcrumb.Item>Employee Loan</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Employee Loan'}
              subtitle={'Employee Loan List'}
              color={'#FF6138'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{padding: 10}}>
          <Card>
            <EmployeeLoanModal {...props} />
            <EmployeeLoanList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

EmployeeLoan.propTypes = {}
EmployeeLoan.defaultProps = {}

export default EmployeeLoan
